var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAccount = function SvgIconAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.01 12C15.7756 12 18 9.76 18 7C18 4.24 15.7756 2 13.01 2C10.2445 2 8 4.24 8 7C8 9.76 10.2445 12 13.01 12Z",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 15C9.67273 15 3 16.656 3 19.95V24H23V19.95C23 16.656 16.3273 15 13 15Z",
    strokeWidth: 3
  })));
};
export default SvgIconAccount;